/**
 * WorkspaceSettingsDialog — store-wired wrapper around SettingsDialog.
 *
 * The base `<SettingsDialog>` is open/section-controlled via props. This
 * wrapper plugs it into `useSettingsDialogsStore` so any descendant of
 * AppLayout can open the dialog (and jump to a specific section) without
 * carrying its own state. Mounted once in `AppLayout`.
 */

import { useSettingsDialogsStore } from "@/store/slices/settings-dialogs-slice"
import { SettingsDialog } from "./settings-dialog"

export function WorkspaceSettingsDialog() {
  const open = useSettingsDialogsStore((s) => s.workspaceSettings.open)
  const initialSection = useSettingsDialogsStore(
    (s) => s.workspaceSettings.initialSection,
  )
  const close = useSettingsDialogsStore((s) => s.closeWorkspaceSettings)

  return (
    <SettingsDialog
      open={open}
      onOpenChange={(next) => !next && close()}
      initialSection={initialSection}
    />
  )
}

WorkspaceSettingsDialog.displayName = "WorkspaceSettingsDialog"
